import React, { useEffect, useState } from "react";
import { getList, getListV2 } from "../../../services/api/Api";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import ActionsDropdown from "../../ActionsDropdown";
import ProductItem from "../../ProductItem/ProductItem";
import PricingProductItem from "../../ProductItem/PricingProductItem";
import ProductListModal from "../WidgetsSettings/ProductList/ProductListSettingsModal";
import { useSelector } from "react-redux";
import { addConnectionsToActionButtons } from "@util/Scripts";
import { showTitle } from "@util/Scripts";
import { getConnectionData, isActivePublicUser } from "../../../util/Scripts";
import "./productList.less";
import { Spin, Pagination } from "../../BP2Components";
import { getListV3 } from "../../../services/restAPI/ListsV2";
import FormV3Controller from "../FormsV3/FormV3Controller";
import { useIntl } from "react-intl";

const modalActions = {
   FORM_ACTION: "FormAction",
};

const ProductListWidget = ({ value, role, data }) => {
   const intl = useIntl();
   const [rows, setRows] = useState([]);
   const [items, setItems] = useState([]);
   const [metaData, setMetaData] = useState();
   const [currentAction, setCurrentAction] = useState();
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(true);
   const [buttons, setButtons] = useState([]);
   const [columns, setColumns] = useState([]);
   const { listWidgetSeries } = value;
   const { currentBoard } = useSelector(({ boards }) => boards);
   const { search } = useSelector(({ settings }) => settings);

   const createItemList = (responseData) => {
      const productList = [];
      responseData.data?.forEach((item) => {
         const product = {};

         responseData.columns?.forEach((column) => {
            product[column?.label] = item[column?.label];
         });
         product["item_id"] =
            item[
               responseData.columns?.find(
                  (item) => item?.options?.techName === value?.[`itemIdColumn`],
               )?.label
            ] && item?.["api_rowMetaData"]?.recordId;

         if (!product["quantity"]) {
            product["quantity"] = 1;
         }

         productList.push(product);
      });
      return productList;
   };

   const handleListResponse = (res) => {
      const columnsCopy = [];
      const responseData = isActivePublicUser()
         ? res?.data?.getPublicList
         : (res?.data?.default ?? res?.data);
      responseData.columns.forEach((column) => {
         columnsCopy.push({
            title: column.label,
            dataIndex: column.label,
            techName: column.options.techName ?? column.techName,
            precision: column?.options?.precision,
         });
      });
      setColumns(columnsCopy);
      setItems(createItemList(responseData));
      setMetaData(responseData?.meta);

      let rowsTable = responseData.data.map((row) => {
         columnsCopy.forEach((column) => {
            if (typeof row[column.dataIndex] === "string") {
               row[column.dataIndex] = row[column.dataIndex];
            } else {
               row[column.dataIndex] = row[column.dataIndex];
            }
         });
         return row;
      });

      const isPlainObject = (value) =>
         typeof value === "object" && value !== null && !Array.isArray(value);
      const isV3 = isPlainObject(responseData?.actions);

      // Here is connection between widgets handled
      let actions = addConnectionsToActionButtons(
         currentBoard?.connections,
         isV3 ? Object.values(responseData.actions) : responseData.meta?.actions,
         value.id,
         value.listId,
         intl,
      );

      if (isV3) {
         actions = Object.values(actions);
      }
      const hasNoNestedArrays = actions?.every((item) => !Array.isArray(item));

      const actionsButtons = rowsTable.map((row, index) => {
         if (
            (hasNoNestedArrays
               ? responseData.actions?.length > 0
               : responseData.actions[index]?.length > 0) ||
            responseData.meta.actions?.length > 0
         )
            return (
               <ActionsDropdown
                  actions={
                     hasNoNestedArrays
                        ? actions?.length > 0
                           ? actions
                           : (responseData?.actions ?? responseData?.meta?.actions)
                        : actions[index].length > 0
                          ? actions[index]
                          : responseData?.actions[index]
                  }
                  rowData={responseData.data[row.key]}
                  rowId={row?.api_rowMetaData?.recordId ?? row?.ID}
                  hiddenDropdown={value?.buttonsInSelectMode}
                  listId={listWidgetSeries[0]?.listId}
                  formAction={formAction}
                  centeredButtons
               />
            );
         return null;
      });
      setButtons(actionsButtons);
      setRows(rowsTable);
      setLoading(false);
   };

   const handlePageChange = (page) => {
      setLoading(true);
      setCurrentPage(page);
   };

   useEffect(() => {
      if (!listWidgetSeries?.[0]?.listId) return;
      const listId = listWidgetSeries[0]?.listId;
      const list = listWidgetSeries[0];
      const isV3 = listId.toString().length > 10;
      if (listId && list.itemsPerPage) {
         let connectionFilter;
         let listFilters;

         if (window?.location) {
            const urlParams = new URLSearchParams(window.location.search);
            listFilters = JSON.parse(decodeURIComponent(urlParams.get("listFilters")));
            connectionFilter = getConnectionData(value.id);
         }

         if (connectionFilter) {
            try {
               getListV2(listId, currentPage, list.itemsPerPage, connectionFilter).then(
                  handleListResponse,
               );
            } catch (err) {
               getListV2(listId, currentPage, list.itemsPerPage).then(handleListResponse);
            }
         } else if (listFilters?.[value.id]) {
            try {
               getListV2(listId, currentPage, list.itemsPerPage, listFilters[value.id]).then(
                  handleListResponse,
               );
            } catch (err) {
               console.error("Error in initial render with filter in URL", err);
            }
         } else {
            if (isV3) {
               getListV3(listId, currentPage, list.itemsPerPage).then(handleListResponse);
            } else {
               getList(listId, currentPage, list.itemsPerPage).then(handleListResponse);
            }
         }
      }
   }, [value, currentPage, search]);

   const formAction = (customEvent) => {
      if (customEvent?.actionName === modalActions.FORM_ACTION) {
         setIsModalOpen(true);
         setCurrentAction({
            type: modalActions.FORM_ACTION,
            formId: customEvent?.actionId,
            dataId: customEvent.rowId,
         });
      }
   };
   return (
      <Widget
         title={showTitle(value.listTitle, value.title, data)}
         styleName="gx-card-profile-sm"
         bgColor={value?.backgroundColourHex}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={"Product List"}
                  widgetId={value?.id}
                  icon="setting"
                  deleteIcon="true"
                  children={
                     <ProductListModal value={value} columns={columns} rows={rows} data={data} />
                  }
               />
            )
         }
         type="productList"
      >
         {currentAction && currentAction?.type === modalActions.FORM_ACTION ? (
            <SettingsModal
               isOpen={isModalOpen}
               setIsOpen={() => setIsModalOpen(!isModalOpen)}
               className={"form-modal"}
               children={
                  <FormV3Controller
                     formId={currentAction.formId}
                     dataId={currentAction.dataId}
                     saveCallback={() => setIsModalOpen(!isModalOpen)}
                  ></FormV3Controller>
               }
            />
         ) : null}
         <div className="productList-container">
            {value.pricingTableView ? (
               <div className="gx-m-3">
                  {items.map((item, index) => (
                     <PricingProductItem
                        key={index}
                        columns={columns}
                        rows={rows?.[index]}
                        item={item}
                        mainTitle={value?.mainTitle}
                        shopName={listWidgetSeries?.[0]?.name}
                        showButtonAddToCart={value?.showButtonAddToCart}
                        showMainTitleLabel={value.showMainTitleLabel}
                        showLabelLabel={value.showLabelLabel}
                        pricingTableView={value.pricingTableView}
                     />
                  ))}
               </div>
            ) : (
               items.map((item, index) => (
                  <ProductItem
                     key={index}
                     columns={columns}
                     rows={rows?.[index]}
                     item={item}
                     buttons={buttons?.[index]}
                     hasPhoto={value?.hasPhoto}
                     photoColumn={value?.photoColumn || "Zdjęcie"}
                     mainTitle={value?.mainTitle}
                     subtitle={value?.subtitle}
                     keyInfo={value?.keyInfo}
                     subKeyInfo={value?.subKeyInfo}
                     description={value?.description}
                     shopName={listWidgetSeries?.[0]?.name}
                     showButtonAddToCart={value?.showButtonAddToCart}
                     showMainTitleLabel={value.showMainTitleLabel}
                     showSubtitleLabel={value.showSubtitleLabel}
                     showLabelLabel={value.showLabelLabel}
                     showKeyInfoLabel={value.showKeyInfoLabel}
                     showSubKeyInfoLabel={value.showSubKeyInfoLabel}
                  />
               ))
            )}
            {loading ? (
               <div id="items-loader" className="items-loader">
                  <Spin />
               </div>
            ) : null}
         </div>
         <div className="pagination-container">
            {metaData?.totalPages > 1 ? (
               <Pagination
                  initialPage={1}
                  totalItems={metaData.totalItemsCount}
                  defaultPageSize={listWidgetSeries[0].itemsPerPage}
                  onChange={(page) => handlePageChange(page)}
               />
            ) : null}
         </div>
      </Widget>
   );
};

export default ProductListWidget;
